export const getBoxShadow = (inViewTop: boolean, inViewBottom: boolean) => {
  if (!inViewTop && !inViewBottom) return 'top-bottom';
  if (!inViewTop) return 'top';
  if (!inViewBottom) return 'bottom';
  return 'none';
};
